import { Stack } from '@mui/material';
import CustomAppBar from 'components/CustomAppBar/CustomAppBar';
import BackButton from 'components/CustomAppBar/components/BackButton/BackButton';
import SubTitle from 'components/CustomAppBar/components/SubTitle/SubTitle';

export default function MyAppBar() {
  return (
    <CustomAppBar>
      <Stack direction="row">
        <BackButton />
        <SubTitle text="افزودن عضو به گفت‌وگو" />
      </Stack>
    </CustomAppBar>
  );
}
